module.exports = __webpack_public_path__ + "static/media/app-badge-google-play.12fa9a85.svg";